import { render } from "./dentistryService.vue?vue&type=template&id=6d726b2c&scoped=true&ts=true"
import script from "./dentistryService.vue?vue&type=script&lang=ts"
export * from "./dentistryService.vue?vue&type=script&lang=ts"

import "./dentistryService.vue?vue&type=style&index=0&id=6d726b2c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lq\\Desktop\\普康\\activity-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d726b2c"]])

export default __exports__